import React, { useEffect } from 'react'
import { FormGroup, FormControl, HelpBlock } from 'react-bootstrap'

import Label from 'live/components/forms/ui/label'
import authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'

import { checkIsValidFrequencyRange } from '../../../../../../../utils'
import { IThreatEditor, IConsequenceEditor, IType } from '../../../../BowtieEditor'
import { ThreatConsequenceModalContainer } from './styles'

type IProps = {
    handleChange: (item: IThreatEditor | IConsequenceEditor) => void
    item: IThreatEditor | IConsequenceEditor
    type: IType
}

export const checkIsInvalidName = (name: string): boolean => {
    return name == null || name === ''
}

export const ThreatConsequenceModal: React.FC<IProps> = ({ item, handleChange, type }) => {
    const [stepCount, setStepCount] = React.useState<string>(undefined)
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    const stepCountFunction = (count: number): void => {
        if (count <= 3 || undefined) {
            setStepCount('0.1')
        } else {
            let aux = ''
            aux = aux.padStart(count - 3, '0')
            setStepCount('0.' + aux + '1')
        }
    }

    useEffect(() => {
        if (type === 'threat') {
            const count = item && (item as IThreatEditor).initialFrequency && (item as IThreatEditor).initialFrequency
            if (count) {
                stepCountFunction(String(count).length)
            }
        } else {
            const count =
                item &&
                (item as IConsequenceEditor).thresholdFrequency &&
                (item as IConsequenceEditor).thresholdFrequency
            if (count) {
                stepCountFunction(String(count).length)
            }
        }

        if (item) handleChange(item)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ThreatConsequenceModalContainer>
            <FormGroup validationState={!checkIsInvalidName(item?.name) ? 'success' : 'error'}>
                <Label required className="control-label">
                    {i18n('Name')}
                </Label>
                {bowtieAdmin ? (
                    <FormControl
                        type="text"
                        onChange={e => handleChange({ ...item, name: (e.target as HTMLInputElement).value })}
                        placeholder={`${i18n('new').toUpperCase()} ${i18n(type).toUpperCase()}`}
                        id="diagramEditor-threatConsequenceModal-field-name"
                        value={item?.name}
                        maxLength={255}
                    />
                ) : (
                    <FormControl
                        type="text"
                        readOnly
                        placeholder={`${i18n('new').toUpperCase()} ${i18n(type).toUpperCase()}`}
                        id="diagramEditor-threatConsequenceModal-field-name"
                        value={item?.name}
                        maxLength={255}
                    />
                )}
            </FormGroup>

            {type === 'threat' ? (
                <>
                    <FormGroup
                        validationState={
                            checkIsValidFrequencyRange((item as IThreatEditor)?.initialFrequency) ? 'success' : 'error'
                        }
                    >
                        <Label required className="control-label">
                            {i18n('Initial Frequency')}
                        </Label>
                        {bowtieAdmin ? (
                            <FormControl
                                type="number"
                                min={0}
                                max={1}
                                step={stepCount}
                                onChange={e => {
                                    const count = (e.target as HTMLInputElement).value
                                    handleChange({ ...item, initialFrequency: Number(count) })
                                    stepCountFunction(count.length)
                                }}
                                id="diagramEditor-threatConsequenceModal-field-initialFrequency"
                                value={(item as IThreatEditor)?.initialFrequency}
                            />
                        ) : (
                            <FormControl
                                type="number"
                                min={0}
                                max={1}
                                step={stepCount}
                                readOnly
                                id="diagramEditor-threatConsequenceModal-field-initialFrequency"
                                value={(item as IThreatEditor)?.initialFrequency}
                            />
                        )}
                        <HelpBlock>{i18n('Value Between 0 and 1')} </HelpBlock>
                    </FormGroup>

                    <HelpBlock>{i18n('Changes made in this interface will occur just in this Bowtie')} </HelpBlock>
                </>
            ) : (
                <>
                    <FormGroup
                        validationState={
                            checkIsValidFrequencyRange((item as IConsequenceEditor)?.thresholdFrequency)
                                ? 'success'
                                : 'error'
                        }
                    >
                        <Label required className="control-label">
                            {i18n('Threshold Frequency')}
                        </Label>
                        {bowtieAdmin ? (
                            <FormControl
                                type="number"
                                min={0}
                                max={1}
                                step={stepCount}
                                onChange={e => {
                                    const count = (e.target as HTMLInputElement).value
                                    handleChange({ ...item, thresholdFrequency: Number(count) })
                                    stepCountFunction(count.length)
                                }}
                                id="diagramEditor-threatConsequenceModal-field-thresholdFrequency"
                                value={(item as IConsequenceEditor)?.thresholdFrequency}
                            />
                        ) : (
                            <FormControl
                                type="number"
                                min={0}
                                max={1}
                                step={stepCount}
                                readOnly
                                id="diagramEditor-threatConsequenceModal-field-thresholdFrequency"
                                value={(item as IConsequenceEditor)?.thresholdFrequency}
                            />
                        )}
                        <HelpBlock>{i18n('Value Between 0 and 1')} </HelpBlock>
                    </FormGroup>
                    <hr />
                    <HelpBlock>{i18n('Changes made in this interface will occur just in this Bowtie')} </HelpBlock>
                </>
            )}
        </ThreatConsequenceModalContainer>
    )
}
